import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Path = styled.path`
  stroke: var(--color-base-light-0);
`;

const ShareIcon = (props) => {
  const { width, height } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.0856 8.45358C6.19754 9.00523 2.50256 13.1385 2.5 18.0576V18.6698C4.62437 16.1107 7.76006 14.6064 11.0856 14.5511V17.7795C11.0857 18.2479 11.3534 18.675 11.775 18.8793C12.1965 19.0836 12.6977 19.029 13.0654 18.7389L21.0587 12.4272C21.3425 12.2036 21.5081 11.8622 21.5081 11.5008C21.5081 11.1395 21.3425 10.7981 21.0587 10.5745L13.0654 4.26283C12.6977 3.97266 12.1965 3.91811 11.775 4.12238C11.3534 4.32664 11.0857 4.75381 11.0856 5.22223V8.45358Z"
        stroke="#F8F8F8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

ShareIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
};

ShareIcon.defaultProps = {
  width: 24,
  height: 24
};

export default ShareIcon;
